import { jsx as e, jsxs as o, Fragment as t } from "react/jsx-runtime";

import n from "@ui-components-3/ui/lib/components/Modal";

import { useRef as l, useCallback as i, useEffect as r } from "react";

import s from "@ui-components-3/ui/lib/components/Loading";

import { useProviderSchedule as a } from "../../hooks/useProviderSchedule.js";

import c from "@ui-components-3/ui/lib/utils/classNames";

const m = ({isSlot: m, onConfirm: u, onClose: p, children: d}) => {
    const {isDeleting: b} = a(), f = l(!1), h = m ? "Time slot" : "Availability block", y = i((() => {
        u?.(), f.current = !0;
    }), [ u ]);
    return r((() => {
        !b && f.current && p?.();
    }), [ b, p ]), e(n, {
        label: `Delete ${h.toLowerCase()}`,
        opened: !0,
        onClose: e => {
            e.stopPropagation(), p?.();
        },
        size: "l",
        footerVariant: "right",
        footer: ({close: n}) => o(t, {
            children: [ e("button", {
                type: "button",
                className: "btn btn-neutral-outlined",
                onClick: n,
                children: "Cancel"
            }), e("button", {
                type: "button",
                className: "btn btn-neutral",
                onClick: y,
                disabled: !!b,
                children: b ? e(s, {
                    shown: !0
                }) : "Delete"
            }) ]
        }),
        children: o("div", {
            className: c("flex flex-col gap-8 pt-4", !d && "pb-4"),
            children: [ o("p", {
                className: "typography-body-xl font-medium text-neutral-800 ",
                children: [ "Are you sure you want to delete this ", h.toLowerCase(), "?" ]
            }), d ]
        })
    });
};

export { m as default };
//# sourceMappingURL=index.js.map
